[
  {
    "gtin": "01000001",
    "name": "Apple Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744808391/products/pim/3600523193196-3118020/l-oreal-paris-magic-retouch-ansatzspray-dunkelbraun-bis-schwarzbraun",
    "imageOutline": {
      "x0": 0.35,
      "y0": 0.0,
      "x1": 0.645,
      "y1": 1.0,
      "aspect": 0.295
    },
    "placements": [
      {
        "shelfId": "L5PL",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4eb9"
      },
      {
        "shelfId": "26S4",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4e91"
      },
      {
        "shelfId": "3XA5",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4e9a"
      }
    ],
    "inventory": {
      "quantity": 23
    }
  },
  {
    "gtin": "01000002",
    "name": "Banana Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.59,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745002006/products/pim/4067796164848-329519398/balea-badesalz-big-dreams",
    "imageOutline": {
      "x0": 0.25,
      "y0": 0.0,
      "x1": 0.75,
      "y1": 1.0,
      "aspect": 0.5
    },
    "placements": [
      {
        "shelfId": "L5PL",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ea4"
      },
      {
        "shelfId": "KVLU",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ec1"
      }
    ],
    "inventory": {
      "quantity": 7
    }
  },
  {
    "gtin": "01000003",
    "name": "Carrot Cake",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744979989/products/pim/4067796014280-628472255/dmbio-bliss-balls-nuss-nougatfuellung",
    "imageOutline": {
      "x0": 0.31,
      "y0": 0.0,
      "x1": 0.695,
      "y1": 1.0,
      "aspect": 0.385
    },
    "placements": [
      {
        "shelfId": "5FV2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ee4"
      },
      {
        "shelfId": "UD1F",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ec4"
      },
      {
        "shelfId": "8K9F",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4f35"
      }
    ],
    "inventory": {
      "quantity": 31
    }
  },
  {
    "gtin": "01000004",
    "name": "Dairy Milk",
    "brandName": "MilkyWay",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744983705/products/pim/4006000083353-699695394/nivea-bodylotion-express-normale-haut",
    "imageOutline": {
      "x0": 0.325,
      "y0": 0.0,
      "x1": 0.675,
      "y1": 1.0,
      "aspect": 0.35
    },
    "placements": [
      {
        "shelfId": "B4C6",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4fe0"
      },
      {
        "shelfId": "6C02",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff500e"
      }
    ],
    "inventory": {
      "quantity": 12
    }
  },
  {
    "gtin": "01000005",
    "name": "Egg Noodles",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744821036/products/pim/4066447276886-3922153/seinz-antitranspirant-deospray-sport",
    "imageOutline": {
      "x0": 0.35,
      "y0": 0.0,
      "x1": 0.65,
      "y1": 1.0,
      "aspect": 0.3
    },
    "placements": [
      {
        "shelfId": "UD1F",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ec5"
      },
      {
        "shelfId": "8K9F",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4f70"
      },
      {
        "shelfId": "6EOH",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff5066"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000006",
    "name": "Fig Bars",
    "brandName": "HealthySnacks",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1757638263/products/pim/4066447468076-2096307163/balea-conditioner-intensivpflege",
    "imageOutline": {
      "x0": 0.3,
      "y0": 0.0,
      "x1": 0.695,
      "y1": 1.0,
      "aspect": 0.395
    },
    "placements": [
      {
        "shelfId": "2ZMB",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5094"
      },
      {
        "shelfId": "DJBZ",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff50c2"
      }
    ],
    "inventory": {
      "quantity": 19
    }
  },
  {
    "gtin": "01000007",
    "name": "Grape Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980572/products/pim/4001499908347-187640752/frosch-baby-baby-spuelreiniger",
    "imageOutline": {
      "x0": 0.28,
      "y0": 0.0,
      "x1": 0.725,
      "y1": 1.0,
      "aspect": 0.445
    },
    "placements": [
      {
        "shelfId": "UH8F",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff508e"
      },
      {
        "shelfId": "ABBX",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff511d"
      },
      {
        "shelfId": "5R7C",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5137"
      }
    ],
    "inventory": {
      "quantity": 4
    }
  },
  {
    "gtin": "01000008",
    "name": "Honey Oats",
    "brandName": "BreakfastBest",
    "baseCategory": "Cereals & Breakfast",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744968742/products/pim/4066447366129-2046346204/balea-bodybalsam-sensitive",
    "imageOutline": {
      "x0": 0.305,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.38
    },
    "placements": [
      {
        "shelfId": "68B1",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5193"
      },
      {
        "shelfId": "KFT1",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff51db"
      }
    ],
    "inventory": {
      "quantity": 28
    }
  },
  {
    "gtin": "01000009",
    "name": "Ice Cream",
    "brandName": "CoolTreats",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 4.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 5.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744728374/products/pim/4104260075450-2240313/swiss-o-par-augenbrauen-und-wimpernfarbe-schwarz",
    "imageOutline": {
      "x0": 0.245,
      "y0": 0.0,
      "x1": 0.76,
      "y1": 1.0,
      "aspect": 0.515
    },
    "placements": [
      {
        "shelfId": "84HF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff522f"
      },
      {
        "shelfId": "S8LF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5262"
      },
      {
        "shelfId": "DNB2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5291"
      },
      {
        "shelfId": "QUSR",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5349"
      }
    ],
    "inventory": {
      "quantity": 15
    }
  },
  {
    "gtin": "01000010",
    "name": "Jelly Beans",
    "brandName": "CandyLand",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748394962/products/pim/4056631003879-1043270438/aptamil-anfangsmilch-1-pronutra-von-geburt-an",
    "imageOutline": {
      "x0": 0.15,
      "y0": 0.0,
      "x1": 0.85,
      "y1": 1.0,
      "aspect": 0.7
    },
    "placements": [
      {
        "shelfId": "YOAF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff53b9"
      },
      {
        "shelfId": "4DL3",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff53ef"
      }
    ],
    "inventory": {
      "quantity": 33
    }
  },
  {
    "gtin": "01000011",
    "name": "Kiwi Jam",
    "brandName": "FruitDelight",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994135/products/pim/3616303424220-1368302704/adidas-after-shave-ice-dive",
    "imageOutline": {
      "x0": 0.005,
      "y0": 0.09,
      "x1": 1.0,
      "y1": 0.91,
      "aspect": 1.2134
    },
    "placements": [
      {
        "shelfId": "15PT",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5f70"
      }
    ],
    "inventory": {
      "quantity": 8
    }
  },
  {
    "gtin": "01000012",
    "name": "Lemonade",
    "brandName": "CitrusFresh",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747636957/products/pim/9120112228732-1352971927/judith-williams-augencreme-kollagen-aktiv-lifting",
    "imageOutline": {
      "x0": 0.24,
      "y0": 0.0,
      "x1": 0.765,
      "y1": 1.0,
      "aspect": 0.525
    },
    "placements": [
      {
        "shelfId": "8FP9",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5738"
      }
    ],
    "inventory": {
      "quantity": 21
    }
  },
  {
    "gtin": "01000013",
    "name": "Mango Lassi",
    "brandName": "Yogurto",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1754702154/products/pim/4066447375114-1223562299/visiomax-brillenputztuecher-10x2",
    "imageOutline": {
      "x0": 0.265,
      "y0": 0.0,
      "x1": 0.73,
      "y1": 1.0,
      "aspect": 0.465
    },
    "placements": [
      {
        "shelfId": "T4J1",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff5755"
      }
    ],
    "inventory": {
      "quantity": 2
    }
  },
  {
    "gtin": "01000014",
    "name": "Nutty Bars",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980050/products/pim/4008617138822-1009462392/klosterfrau-arnika-intensiv-creme",
    "imageOutline": {
      "x0": 0.34,
      "y0": 0.0,
      "x1": 0.66,
      "y1": 1.0,
      "aspect": 0.32
    },
    "placements": [
      {
        "shelfId": "JZYK",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff5790"
      }
    ],
    "inventory": {
      "quantity": 26
    }
  },
  {
    "gtin": "01000015",
    "name": "Olive Oil",
    "brandName": "PurePress",
    "baseCategory": "Oils & Vinegars",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748996898/products/pim/4895248007746-1506741479/rascals-baby-pants-premium-gr-5-13-18-kg",
    "imageOutline": {
      "x0": 0.165,
      "y0": 0.0,
      "x1": 0.835,
      "y1": 1.0,
      "aspect": 0.67
    },
    "placements": [
      {
        "shelfId": "KKXB",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff580b"
      }
    ],
    "inventory": {
      "quantity": 10
    }
  },
  {
    "gtin": "01000016",
    "name": "Peach Tea",
    "brandName": "TeaTime",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744829593/products/pim/4066447237542-4139974/balea-after-shave-pflege-gel-sensitive",
    "imageOutline": {
      "x0": 0.305,
      "y0": 0.0,
      "x1": 0.685,
      "y1": 1.0,
      "aspect": 0.38
    },
    "placements": [
      {
        "shelfId": "FAGG",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff5845"
      }
    ],
    "inventory": {
      "quantity": 35
    }
  },
  {
    "gtin": "01000017",
    "name": "Quinoa Salad",
    "brandName": "HealthyChoice",
    "baseCategory": "Salads",
    "reportedPrice": {
      "amount": 4.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744996004/products/pim/4018852029342-623756578/bebivita-abendbrei-griess-banane-apfel-ab-dem-5-monat",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.62
    },
    "placements": [
      {
        "shelfId": "FPWP",
        "stockLevel": "UNKNOWN",
        "facingId": "679afb3d3d9bab0f83ff582e"
      }
    ],
    "inventory": {
      "quantity": 13
    }
  },
  {
    "gtin": "01000018",
    "name": "Raspberry Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998905/products/pim/3574661816005-1823653615/penaten-babyoel-intensiv",
    "imageOutline": {
      "x0": 0.275,
      "y0": 0.0,
      "x1": 0.72,
      "y1": 1.0,
      "aspect": 0.445
    },
    "placements": [
      {
        "shelfId": "YT1C",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff614a"
      }
    ],
    "inventory": {
      "quantity": 29
    }
  },
  {
    "gtin": "01000019",
    "name": "Strawberry Jam",
    "brandName": "BerryBest",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745006037/products/pim/3574661332628-1795371507/neutrogena-anti-pickel-feuchtigkeitscreme",
    "imageOutline": {
      "x0": 0.33,
      "y0": 0.005,
      "x1": 0.67,
      "y1": 1.0,
      "aspect": 0.3417
    },
    "placements": [
      {
        "shelfId": "AQ5L",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff585d"
      }
    ],
    "inventory": {
      "quantity": 6
    }
  },
  {
    "gtin": "01000020",
    "name": "Tomato Soup",
    "brandName": "SoupMaster",
    "baseCategory": "Canned & Jarred",
    "reportedPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744973161/products/pim/4066447429121-1900720101/balea-augen-make-up-entferner-oelfrei",
    "imageOutline": {
      "x0": 0.31,
      "y0": 0.0,
      "x1": 0.695,
      "y1": 1.0,
      "aspect": 0.385
    },
    "placements": [
      {
        "shelfId": "N3JI",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff63a1"
      }
    ],
    "inventory": {
      "quantity": 17
    }
  },
  {
    "gtin": "01000021",
    "name": "Udon Noodles",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748394669/products/pim/4056631003701-513862772/aptamil-anfangsmilch-pre-pronutra-von-geburt-an",
    "imageOutline": {
      "x0": 0.15,
      "y0": 0.0,
      "x1": 0.85,
      "y1": 1.0,
      "aspect": 0.7
    },
    "placements": [
      {
        "shelfId": "S8LF",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5286"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000022",
    "name": "Vanilla Pudding",
    "brandName": "SweetTreats",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744973472/products/pim/4066447505542-1333231541/paradies-bilderrahmen-flat-finish-13x18-cm-weiss",
    "imageOutline": {
      "x0": 0.12,
      "y0": 0.0,
      "x1": 0.885,
      "y1": 1.0,
      "aspect": 0.765
    },
    "placements": [
      {
        "shelfId": "JZYK",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3d3d9bab0f83ff57aa"
      }
    ],
    "inventory": {
      "quantity": 24
    }
  },
  {
    "gtin": "01000023",
    "name": "Walnut Brownies",
    "brandName": "NuttyBakes",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744995832/products/pim/4260133231351-539688817/fruchtbar-babysnack-mehrkorn-stangen-mit-mais-dinkel-banane-und-erdbeere-ab-8-monaten",
    "imageOutline": {
      "x0": 0.225,
      "y0": 0.0,
      "x1": 0.775,
      "y1": 1.0,
      "aspect": 0.55
    },
    "placements": [
      {
        "shelfId": "TNRU",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5ba2"
      }
    ],
    "inventory": {
      "quantity": 11
    }
  },
  {
    "gtin": "01000024",
    "name": "Xylitol Gum",
    "brandName": "FreshChew",
    "baseCategory": "Gum & Mints",
    "reportedPrice": {
      "amount": 0.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1756861507/products/pim/4062300414310-1879218932/hipp-anfangsmilch-pre-von-geburt-an",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.62
    },
    "placements": [
      {
        "shelfId": "0DV8",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5945"
      }
    ],
    "inventory": {
      "quantity": 32
    }
  },
  {
    "gtin": "01000025",
    "name": "Yogurt Drink",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748394669/products/pim/4056631003701-513862772/aptamil-anfangsmilch-pre-pronutra-von-geburt-an",
    "imageOutline": {
      "x0": 0.15,
      "y0": 0.0,
      "x1": 0.85,
      "y1": 1.0,
      "aspect": 0.7
    },
    "placements": [
      {
        "shelfId": "PKZ7",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5fe4"
      }
    ],
    "inventory": {
      "quantity": 1
    }
  },
  {
    "gtin": "01000026",
    "name": "Zucchini Bread",
    "brandName": "VeggieBake",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1749260587/products/pim/4103040616012-170360873/sebamed-bodylotion-feuchtigkeitspflege-mit-kamillenextrakt",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.035,
      "x1": 0.69,
      "y1": 1.0,
      "aspect": 0.3886
    },
    "placements": [
      {
        "shelfId": "ABBX",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5119"
      }
    ],
    "inventory": {
      "quantity": 18
    }
  },
  {
    "gtin": "01000027",
    "name": "Almond Milk",
    "brandName": "NutriMilk",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744722425/products/pim/4058172389528-2078656/dmbio-berg-linsen",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.62
    },
    "placements": [
      {
        "shelfId": "KFT1",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff51db"
      }
    ],
    "inventory": {
      "quantity": 25
    }
  },
  {
    "gtin": "01000028",
    "name": "Berry Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998172/products/pim/4066447668698-902956023/babylove-baby-pants-premium-gr-6-xl-18-30-kg-jumbo-pack",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.04,
      "x1": 1.0,
      "y1": 0.96,
      "aspect": 1.087
    },
    "placements": [
      {
        "shelfId": "3R6D",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6317"
      }
    ],
    "inventory": {
      "quantity": 9
    }
  },
  {
    "gtin": "01000029",
    "name": "Coconut Water",
    "brandName": "TropicalTaste",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980132/products/pim/4066447710168-97157623/babylove-baby-badezusatz-2in1-bad-und-shampoo-ultra-sensitive",
    "imageOutline": {
      "x0": 0.315,
      "y0": 0.0,
      "x1": 0.68,
      "y1": 1.0,
      "aspect": 0.365
    },
    "placements": [
      {
        "shelfId": "DNB2",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff529d"
      }
    ],
    "inventory": {
      "quantity": 34
    }
  },
  {
    "gtin": "01000030",
    "name": "Date Bars",
    "brandName": "HealthySnacks",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745006992/products/pim/4006000131511-258594470/hidrofugal-antitranspirant-deospray-anti-flecken",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.0,
      "x1": 1.0,
      "y1": 1.0,
      "aspect": 1.0
    },
    "placements": [
      {
        "shelfId": "5PXX",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff5523"
      }
    ],
    "inventory": {
      "quantity": 14
    }
  },
  {
    "gtin": "01000031",
    "name": "Earl Grey Tea",
    "brandName": "TeaTime",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.29,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985269/products/pim/4066447782288-1814773585/hallohebamme-babyoel-baeuchlein",
    "imageOutline": {
      "x0": 0.27,
      "y0": 0.0,
      "x1": 0.735,
      "y1": 1.0,
      "aspect": 0.465
    },
    "placements": [
      {
        "shelfId": "QX44",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5a6d"
      }
    ],
    "inventory": {
      "quantity": 27
    }
  },
  {
    "gtin": "01000032",
    "name": "Fruit Punch",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1755130029/products/pim/4011448001104-761711982/kaufm-creme-baby-und-kinder-pflegecreme",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.005,
      "x1": 1.0,
      "y1": 1.0,
      "aspect": 1.005
    },
    "placements": [
      {
        "shelfId": "FAGG",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff581b"
      }
    ],
    "inventory": {
      "quantity": 3
    }
  },
  {
    "gtin": "01000033",
    "name": "Ginger Ale",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000802/products/pim/4056631003923-126605625/aptamil-anfangsmilch-pre-von-geburt-an",
    "imageOutline": {
      "x0": 0.19,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.62
    },
    "placements": [
      {
        "shelfId": "VYWH",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5cc1"
      }
    ],
    "inventory": {
      "quantity": 20
    }
  },
  {
    "gtin": "01000034",
    "name": "Hazelnut Spread",
    "brandName": "NuttyBakes",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745000277/products/pim/4015100816402-176765706/schwarzkopf-ansatzset-a4-dunkelbraun",
    "imageOutline": {
      "x0": 0.28,
      "y0": 0.0,
      "x1": 0.76,
      "y1": 1.0,
      "aspect": 0.48
    },
    "placements": [
      {
        "shelfId": "BY8E",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff6003"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000035",
    "name": "Italian Pasta",
    "brandName": "NoodleNest",
    "baseCategory": "Pasta & Noodles",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985176/products/pim/7610700946541-1611986516/ricola-bonbon-cranberry-zuckerfrei-in-der-taschenbox",
    "imageOutline": {
      "x0": 0.165,
      "y0": 0.0,
      "x1": 0.835,
      "y1": 1.0,
      "aspect": 0.67
    },
    "placements": [
      {
        "shelfId": "OH53",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4f2b"
      }
    ],
    "inventory": {
      "quantity": 5
    }
  },
  {
    "gtin": "01000036",
    "name": "Jackfruit Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1757645085/products/pim/3574661818207-1232467348/penaten-baby-pflegecreme-gesicht-und-koerper-intensiv",
    "imageOutline": {
      "x0": 0.01,
      "y0": 0.0,
      "x1": 0.99,
      "y1": 1.0,
      "aspect": 0.98
    },
    "placements": [
      {
        "shelfId": "J7M1",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6452"
      }
    ],
    "inventory": {
      "quantity": 30
    }
  },
  {
    "gtin": "01000037",
    "name": "Kale Salad",
    "brandName": "HealthyChoice",
    "baseCategory": "Salads",
    "reportedPrice": {
      "amount": 3.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 4.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744977794/products/pim/88300104680-1292239242/calvin-klein-ck-be-eau-de-toilette",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.03,
      "x1": 1.0,
      "y1": 0.975,
      "aspect": 1.0582
    },
    "placements": [
      {
        "shelfId": "R1N8",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5e1f"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000038",
    "name": "Lime Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744978313/products/pim/4066447581867-1229372302/visiomax-augenspray-sensitiv",
    "imageOutline": {
      "x0": 0.17,
      "y0": 0.0,
      "x1": 0.83,
      "y1": 1.0,
      "aspect": 0.66
    },
    "placements": [
      {
        "shelfId": "MF11",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff62fe"
      }
    ],
    "inventory": {
      "quantity": 0
    }
  },
  {
    "gtin": "01000039",
    "name": "Mint Chutney",
    "brandName": "TropicalTaste",
    "baseCategory": "Condiments",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1754702154/products/pim/4066447375114-1223562299/visiomax-brillenputztuecher-10x2",
    "imageOutline": {
      "x0": 0.265,
      "y0": 0.0,
      "x1": 0.73,
      "y1": 1.0,
      "aspect": 0.465
    },
    "placements": [
      {
        "shelfId": "RA6K",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5b9f"
      }
    ],
    "inventory": {
      "quantity": 7
    }
  },
  {
    "gtin": "01000040",
    "name": "Orange Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1749205490/products/pim/4067796182354-1302279549/balea-conditioner-farbglanz",
    "imageOutline": {
      "x0": 0.3,
      "y0": 0.0,
      "x1": 0.7,
      "y1": 1.0,
      "aspect": 0.4
    },
    "placements": [
      {
        "shelfId": "MM45",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff62cf"
      }
    ],
    "inventory": {
      "quantity": 35
    }
  },
  {
    "gtin": "01000041",
    "name": "Papaya Jam",
    "brandName": "FruitDelight",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745001518/products/pim/8720181291890-1814439390/dove-antitranspirant-deospray-advanced-care-summer-care",
    "imageOutline": {
      "x0": 0.385,
      "y0": 0.0,
      "x1": 0.62,
      "y1": 1.0,
      "aspect": 0.235
    },
    "placements": [
      {
        "shelfId": "HY2A",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5f0d"
      }
    ],
    "inventory": {
      "quantity": 12
    }
  },
  {
    "gtin": "01000042",
    "name": "Quince Jelly",
    "brandName": "BerryBest",
    "baseCategory": "Spreads",
    "reportedPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.39,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998129/products/pim/4051424570002-2109712607/dr-scheller-anti-falten-gesichtscreme-argan",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.105,
      "x1": 1.0,
      "y1": 0.89,
      "aspect": 1.2739
    },
    "placements": [
      {
        "shelfId": "CL5L",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5aa9"
      }
    ],
    "inventory": {
      "quantity": 19
    }
  },
  {
    "gtin": "01000043",
    "name": "Raisin Bread",
    "brandName": "VeggieBake",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980898/products/pim/4066447710083-413034/babylove-baby-kopf-bis-fuss-waschgel-nachfuellpack",
    "imageOutline": {
      "x0": 0.215,
      "y0": 0.005,
      "x1": 0.79,
      "y1": 1.0,
      "aspect": 0.5779
    },
    "placements": [
      {
        "shelfId": "85BT",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3c3d9bab0f83ff4ef5"
      }
    ],
    "inventory": {
      "quantity": 22
    }
  },
  {
    "gtin": "01000044",
    "name": "Spinach Wrap",
    "brandName": "HealthyChoice",
    "baseCategory": "Wraps & Tortillas",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744981053/products/pim/4008871200945-1507941193/toppits-alufolie-extra-reissfest",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.405,
      "x1": 1.0,
      "y1": 0.595,
      "aspect": 5.2632
    },
    "placements": [
      {
        "shelfId": "3LN7",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3d3d9bab0f83ff54a1"
      }
    ],
    "inventory": {
      "quantity": 35
    }
  },
  {
    "gtin": "01000045",
    "name": "Tapioca Pudding",
    "brandName": "SweetTreats",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1748394962/products/pim/4056631003879-1043270438/aptamil-anfangsmilch-1-pronutra-von-geburt-an",
    "imageOutline": {
      "x0": 0.15,
      "y0": 0.0,
      "x1": 0.85,
      "y1": 1.0,
      "aspect": 0.7
    },
    "placements": [
      {
        "shelfId": "7YAR",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5b3b"
      }
    ],
    "inventory": {
      "quantity": 11
    }
  },
  {
    "gtin": "01000046",
    "name": "Ugli Fruit Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1757203639/products/pim/4062300419414-1438952788/hipp-babysanft-baby-pflegecreme-sensitiv",
    "imageOutline": {
      "x0": 0.265,
      "y0": 0.0,
      "x1": 0.73,
      "y1": 1.0,
      "aspect": 0.465
    },
    "placements": [
      {
        "shelfId": "1SKP",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5be8"
      }
    ],
    "inventory": {
      "quantity": 18
    }
  },
  {
    "gtin": "01000047",
    "name": "Vanilla Wafers",
    "brandName": "CookieJar",
    "baseCategory": "Sweets & Confectionery",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.59,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1757203639/products/pim/4062300419377-643411282/hipp-babysanft-baby-shampoo-sensitiv",
    "imageOutline": {
      "x0": 0.285,
      "y0": 0.0,
      "x1": 0.715,
      "y1": 1.0,
      "aspect": 0.43
    },
    "placements": [
      {
        "shelfId": "2V4N",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5bf9"
      }
    ],
    "inventory": {
      "quantity": 12
    }
  },
  {
    "gtin": "01000048",
    "name": "Watermelon Soda",
    "brandName": "FizzPop",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 0.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.09,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1750903440/products/pim/80808756-149625367/borotalco-antitranspirant-deostick-original",
    "imageOutline": {
      "x0": 0.26,
      "y0": 0.0,
      "x1": 0.745,
      "y1": 1.0,
      "aspect": 0.485
    },
    "placements": [
      {
        "shelfId": "SV6R",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5f32"
      }
    ],
    "inventory": {
      "quantity": 35
    }
  },
  {
    "gtin": "01000049",
    "name": "Xtra Crunch Chips",
    "brandName": "SnackCo",
    "baseCategory": "Snacks",
    "reportedPrice": {
      "amount": 1.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994541/products/pim/4260133234802-1200395499/fruchtbar-pausenfreund-brotaufstrich-kakao-creme-cashew-und-dattel-ab-3-jahren",
    "imageOutline": {
      "x0": 0.145,
      "y0": 0.0,
      "x1": 0.86,
      "y1": 1.0,
      "aspect": 0.715
    },
    "placements": [
      {
        "shelfId": "K8RP",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5ed7"
      }
    ],
    "inventory": {
      "quantity": 5
    }
  },
  {
    "gtin": "01000050",
    "name": "Yam Fries",
    "brandName": "VeggieBake",
    "baseCategory": "Frozen Foods",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744985426/products/pim/8714789952543-605665121/ajax-allzweckreiniger-frischeduft",
    "imageOutline": {
      "x0": 0.32,
      "y0": 0.0,
      "x1": 0.68,
      "y1": 1.0,
      "aspect": 0.36
    },
    "placements": [
      {
        "shelfId": "15PT",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5ec2"
      }
    ],
    "inventory": {
      "quantity": 30
    }
  },
  {
    "gtin": "01000051",
    "name": "Apple Cider",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744998253/products/pim/8700216678445-788450549/ariel-colorwaschmittel-pods",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.21,
      "x1": 1.0,
      "y1": 0.79,
      "aspect": 1.7241
    },
    "placements": [
      {
        "shelfId": "KD7C",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5e8f"
      }
    ],
    "inventory": {
      "quantity": 25
    }
  },
  {
    "gtin": "01000052",
    "name": "Apple Pie",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744980303/products/pim/8711600504141-1453033275/rexona-antitranspirant-deocreme-maximum-protection-confidence",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.045,
      "x1": 1.0,
      "y1": 0.96,
      "aspect": 1.0929
    },
    "placements": [
      {
        "shelfId": "BY8E",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5efd"
      }
    ],
    "inventory": {
      "quantity": 18
    }
  },
  {
    "gtin": "01000053",
    "name": "Banana Bread",
    "brandName": "CookieJar",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 3.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744816794/products/pim/4066447311624-3764926/profissimo-cocktailservietten-wie-schoen-25x25-cm",
    "imageOutline": {
      "x0": 0.0,
      "y0": 0.005,
      "x1": 1.0,
      "y1": 0.995,
      "aspect": 1.0101
    },
    "placements": [
      {
        "shelfId": "HY2A",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff5eaf"
      }
    ],
    "inventory": {
      "quantity": 9
    }
  },
  {
    "gtin": "01000054",
    "name": "Banana Smoothie",
    "brandName": "SmoothieKing",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 2.99,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 3.19,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744994670/products/pim/3616303440558-632903833/adidas-antitranspirant-deospray-women-control",
    "imageOutline": {
      "x0": 0.37,
      "y0": 0.0,
      "x1": 0.63,
      "y1": 1.0,
      "aspect": 0.26
    },
    "placements": [
      {
        "shelfId": "15PT",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff606e"
      }
    ],
    "inventory": {
      "quantity": 35
    }
  },
  {
    "gtin": "01000055",
    "name": "Carrot Juice",
    "brandName": "FreshFarms",
    "baseCategory": "Beverages",
    "reportedPrice": {
      "amount": 1.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 1.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744999302/products/pim/4066447668612-1261545513/babylove-baby-pants-premium-gr-5-junior-13-20-kg",
    "imageOutline": {
      "x0": 0.155,
      "y0": 0.0,
      "x1": 0.84,
      "y1": 1.0,
      "aspect": 0.685
    },
    "placements": [
      {
        "shelfId": "FR98",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3e3d9bab0f83ff61ad"
      }
    ],
    "inventory": {
      "quantity": 14
    }
  },
  {
    "gtin": "01000056",
    "name": "Carrot Muffin",
    "brandName": "SweetTreats",
    "baseCategory": "Bakery",
    "reportedPrice": {
      "amount": 2.49,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 2.69,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744997450/products/pim/4021457637416-2054531357/lavera-naturkosmetik-bodylotion-basis-sensitiv-express",
    "imageOutline": {
      "x0": 0.35,
      "y0": 0.0,
      "x1": 0.65,
      "y1": 1.0,
      "aspect": 0.3
    },
    "placements": [
      {
        "shelfId": "4G76",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3e3d9bab0f83ff61bc"
      }
    ],
    "inventory": {
      "quantity": 35
    }
  },
  {
    "gtin": "01000057",
    "name": "Dairy Yogurt",
    "brandName": "DairyDream",
    "baseCategory": "Dairy",
    "reportedPrice": {
      "amount": 0.79,
      "currency": "EUR"
    },
    "catalogPrice": {
      "amount": 0.89,
      "currency": "EUR"
    },
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1745006031/products/pim/3574661332574-585676595/neutrogena-anti-pickel-gesichtsmaske-2in1",
    "imageOutline": {
      "x0": 0.25,
      "y0": 0.0,
      "x1": 0.755,
      "y1": 1.0,
      "aspect": 0.505
    },
    "placements": [
      {
        "shelfId": "WZMI",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff620a"
      }
    ],
    "inventory": {
      "quantity": 35
    }
  },
  {
    "gtin": "9100000161723",
    "name": "Dairy Cheese",
    "brandName": "MilkyWay",
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1744751902/products/pim/4058172716232-2429827/dmbio-basmatireis-aus-vollkorn",
    "imageOutline": {
      "x0": 0.185,
      "y0": 0.0,
      "x1": 0.81,
      "y1": 1.0,
      "aspect": 0.625
    },
    "placements": [
      {
        "shelfId": "OLCA",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff6259"
      }
    ],
    "inventory": {
      "quantity": 35
    }
  },
  {
    "gtin": "01000059",
    "name": "Egg Salad",
    "brandName": "HealthyChoice",
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1746426674/products/pim/4058172101311-3345448/mivolis-calcium-d3-tabletten-300-st",
    "imageOutline": {
      "x0": 0.24,
      "y0": 0.005,
      "x1": 0.76,
      "y1": 1.0,
      "aspect": 0.5226
    },
    "placements": [
      {
        "shelfId": "JBAS",
        "stockLevel": "HAS_STOCK",
        "facingId": "679afb3f3d9bab0f83ff622a"
      }
    ],
    "inventory": {
      "quantity": 35
    }
  },
  {
    "gtin": "01000060",
    "name": "Egg Tart",
    "brandName": "SweetTreats",
    "imageUrl": "https://media.dm-static.com/images/f_auto,q_auto,c_pad,w_200,h_200,b_transparent/v1747307598/products/pim/9005800379227-982780705/nivea-men-antitranspirant-deospray-alpine-breeze",
    "imageOutline": {
      "x0": 0.365,
      "y0": 0.0,
      "x1": 0.63,
      "y1": 1.0,
      "aspect": 0.265
    },
    "placements": [
      {
        "shelfId": "MM45",
        "stockLevel": "NO_STOCK",
        "facingId": "679afb3f3d9bab0f83ff62fa"
      }
    ],
    "inventory": {
      "quantity": 35
    }
  }
]